// extracted by mini-css-extract-plugin
export var button = "_n1-2";
export var card = "_n1-0";
export var closeButtonContainer = "_n1-3";
export var iconContainer = "_n1-1";